import { HiOfficeBuilding, HiCalendar } from "react-icons/hi";
import { HiCurrencyDollar } from "react-icons/hi2";
import { Avatar } from "flowbite-react";

import { useFeatureFlag, FEATURE_FLAGS } from "../../../contexts";
import { PilotStageBar } from "./PilotStageBar";

export const CustomerHeader = ({ account }) => {
  const { logo, name, arr, clientSince, subscriptionStatus, pilot } = account;
  const pilotEnabled = useFeatureFlag(FEATURE_FLAGS.PILOT_PIPELINE_SUPPORT);
  // Gate every pilot surface in the header (badge + stage bar) behind the flag.
  const showPilot = pilotEnabled && subscriptionStatus === "pilot";
  // The bar only renders when the team has configured pilot stages; hide the
  // whole bordered section otherwise so we don't show an empty rule.
  const showStageBar = showPilot && pilot?.stages?.length > 0;

  return (
    <div className="sticky top-0 z-10 border-b border-gray-200/60 bg-white/80 backdrop-blur-md">
      <div className="mx-auto w-full max-w-7xl px-4 py-5 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3">
          {logo ? (
            <Avatar img={logo} size="md" rounded />
          ) : (
            <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-blue-50">
              <HiOfficeBuilding className="size-5 text-blue-600" />
            </div>
          )}
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-xl font-bold text-gray-900">{name}</h1>
              {showPilot && (
                <span className="inline-flex items-center rounded border border-blue-200 bg-blue-50 px-2 py-0.5 text-xs font-semibold text-blue-700">
                  Pilot
                </span>
              )}
            </div>
            <p className="mt-0.5 flex items-center gap-2 text-xs text-gray-500">
              <span className="flex items-center gap-1">
                <HiCurrencyDollar className="size-3" />
                ARR {arr}
              </span>
              <span className="text-gray-300">|</span>
              <span className="flex items-center gap-1">
                <HiCalendar className="size-3" />
                Client since {clientSince}
              </span>
            </p>
          </div>
        </div>

        {showStageBar && (
          <div className="mt-4 border-t border-gray-100 pt-4">
            <PilotStageBar
              stages={pilot.stages}
              currentStageId={pilot.currentStageId}
            />
          </div>
        )}
      </div>
    </div>
  );
};
